/**
 * This function tells the impact of the checkin event that
 * whether checkin resulted in increase/decrease of progress
 * @param checkin
 * @param kr
 * @returns {string}
 */
export default (checkin, kr) => {
  if (kr.start < kr.end) {
    return checkin.newCurrent > checkin.oldCurrent ? 'INCREASING' : 'DECREASING'
  } else {
    return checkin.newCurrent > checkin.oldCurrent ? 'DECREASING' : 'INCREASING'
  }
}
